import React, { Component } from 'react'
import ReactDOM from "react-dom";
import 'jquery/dist/jquery.min.js';
import ls from 'local-storage'
//Datatable Modules
import "datatables.net-dt/js/dataTables.dataTables"
import "datatables.net-dt/css/jquery.dataTables.min.css"
import $ from 'jquery'; 


class Office extends Component {
    componentDidMount(){
        document.title = "Offices List"
        const loginToken = ls.get('loginToken');
        this.$el =$(this.el);
        this.$el.DataTable({
            "scrollY":        "500px",
            "scrollX":        true,
            "scrollCollapse": true,	   
            "aLengthMenu": [
                [10,25, 50, 100, -1],
                [10,25, 50, 100, "All"]
            ],		
            "processing": true,
            'language': {
                'loadingRecords': '&nbsp;',
                'processing': '<div class="spinner_datatable"></div>'
            },
            "serverSide": true,
            "ajax": {
                    url : `${process.env.REACT_APP_API_URL}master/getofficeslist`,
                    type: "POST" ,          
                    headers: { 'Authorization': 'bearer '+loginToken }
            },	
            "columnDefs": [ {
                "searchable": false,
                "orderable": false,
                "targets":[0]
            }],
            "order": [[ 1, 'DESC' ]],
            "columns": [
                {
                  title: "Office Code",
                  data:"officeid"
                }, {
                  title: "Office Name",
                  data:"office_name"
                }, {
                  title: "Parent Office Name",
                  data:"parent_officename"
                }, {
                  title: "Department Name",
                  data:"department_name"
                }, {
                  title: "Edit",
                  data:"id",
                  createdCell: (td, cellData, rowData) =>
                  ReactDOM.render(
                       <button
                         className="btn btn-success"
                         onClick={() => {
                         this.handleEdit(rowData.id);
                         }}
                        > <i className="fa fa-edit"></i> </button>, td 
                        )
                }]
        }
        )
      }
      componentWillUnmount() {
        this.$el =$(this.el);
        this.$el.DataTable().destroy(true);
      }    
      handleEdit(id){    		
        this.props.history.push({  
            pathname: '/officesetup/' + id  
          });
      }
      handleDelete(id){    		
        //console.log(id);
      }       
    render() {
        return (
            <div className="content-wrapper">
            <section className="content-header">
              <h1>
              Office Master
              </h1>
              <ol className="breadcrumb">
                <li><i className="fa fa-dashboard"></i> Home</li>
                <li className="active">Office Master</li>
              </ol>
            </section>
            <section className="content">
              <div className="box">
                  <div className="box-body">
                    <div className="col-md-12">
                    <table className="table table-hover table-bordered" width="100%" ref={el => this.el =el}></table>     
                         </div>
                    </div>
              </div>
            </section>
            </div> 
        )
    }
}
export default Office